// Completing a task FROM THE BOX (busy-my-web#415, Figma 40008879-383276).
//
// The frame ends the open task's action row with a green tick and puts "✓ Completed" where the due
// status was. Both halves are one question — is this task done? — asked of records that spell it
// three different ways: the list's `status: 'done'`, the API's numeric status, and the edit
// payload's `completedDate`. One reading here, so the tick, the Briefing chip and the store request
// can never disagree.
//
// The store request is the SAME one the listing row's tick sends (`task/updateStatus`, Task
// TaskItemQuickActions.vue): 2 marks complete, 1 puts it back. Nothing new is invented on this
// side — the box simply gains the gesture the row already had.

/** Task status numbers, as busy-task-srv names them. */
export const TASK_STATUS = { open: 1, done: 2, waitingOn: 4 }

/** Is this task record complete, however the store that produced it spells it? */
export const isTaskCompleted = (entity) => {
  if (!entity) return false
  const status = entity.status
  if (status === TASK_STATUS.done) return true
  const word = String(status || '').toLowerCase()
  if (word === 'done' || word === 'completed') return true
  return entity.completedDate != null && entity.completedDate !== ''
}

/**
 * The `task/updateStatus` request that TOGGLES a task: complete when it is open, open when it is
 * complete. Null without an id — there is nothing to ask about.
 */
export const completeToggleRequest = (id, completed) => {
  const taskId = id == null ? '' : String(id)
  if (!taskId) return null
  return { ids: [taskId], status: completed ? TASK_STATUS.open : TASK_STATUS.done }
}

/** The tick's tooltip / aria-label, both faces. */
export const completeLabel = (completed) => (completed ? 'Mark as not complete' : 'Mark as complete')

// The green the frame draws the tick and the "Completed" chip in — the design sheet's
// `state/completed`.
export const COMPLETED_COLOR = '#00bd62'

export default isTaskCompleted
